/**
 * Sky Upsell v1.0.0
 * Handles add-to-cart for upsell products with Montage/Shipping sync.
 * Works alongside sky-discount-system.js — uses its exported functions:
 *   - window.getAssemblyPreference()
 *   - window.setLinkedShippingVariantId()
 *   - window.syncMontageInCart()
 *   - window.syncShippingInCart()
 *   - window.applyCartDrawerDiscounts()
 *   - window.applyCartPageDiscounts()
 */
(function () {
  "use strict";

  function getMontagePropertyKey() {
    var labels = { en: "Für", de: "Für", fr: "Pour", it: "Per" };
    var lang = (document.documentElement.lang || "de").split("-")[0].toLowerCase();
    return labels[lang] || "Für";
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-upsell-add]");
    if (!btn || btn.disabled) return;

    e.preventDefault();
    var item = btn.closest("[data-upsell-item]");
    if (!item) return;

    var variantId = btn.getAttribute("data-variant-id");
    if (!variantId) return;

    var productTitle = item.getAttribute("data-product-title") || "";
    var variantTitle = item.getAttribute("data-variant-title") || "";
    var forValue = productTitle;
    if (variantTitle && variantTitle !== "Default Title") {
      forValue += " " + variantTitle;
    }

    // Loading state
    btn.disabled = true;
    btn.classList.add("thb-loading");

    var pref = window.getAssemblyPreference ? window.getAssemblyPreference() : 1;
    var propertyKey = getMontagePropertyKey();
    var items = [{ id: parseInt(variantId), quantity: 1 }];

    // Store linked variant relationships BEFORE adding to cart
    var linkedMontageIds = item.getAttribute("data-linked-montage-ids");
    var linkedShippingId = item.getAttribute("data-linked-shipping-id");

    if (linkedMontageIds) {
      var montageId = linkedMontageIds.split(",")[0];
      try {
        var rel = JSON.parse(localStorage.getItem("montageRelationships") || "{}");
        rel[String(variantId)] = String(montageId);
        localStorage.setItem("montageRelationships", JSON.stringify(rel));
      } catch (ex) {}

      // Button 2 (Montage): add linked montage item
      if (pref === 2 && montageId) {
        var props = {};
        props[propertyKey] = forValue;
        items.push({ id: parseInt(montageId), quantity: 1, properties: props });
      }
    }

    if (linkedShippingId) {
      if (window.setLinkedShippingVariantId) {
        window.setLinkedShippingVariantId(variantId, linkedShippingId);
      }

      // Button 1 (Eigenmontage): add shipping item
      if (pref === 1) {
        var props = {};
        props[propertyKey] = forValue;
        items.push({ id: parseInt(linkedShippingId), quantity: 1, properties: props });
      }
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error("Upsell add failed: " + res.status);
        return res.json();
      })
      .then(function () {
        // Konsolidierender Sync (Montage + Versand + Baugesuch in einem Durchlauf).
        //
        // ISSUE-005 (27.07.2026): Hier liefen frueher syncMontageInCart + syncShippingInCart.
        // syncShippingInCart ist die alte Logik, die PRO Hauptprodukt eine Versandzeile fuehrt —
        // dadurch entstand beim Zubehoer-Upsell eine zweite Versandpauschale (2x CHF 350),
        // obwohl syncCartFast seit 20.07.2026 auf genau EINE Versandzeile pro Bestellung
        // konsolidiert. Ergebnis: Der Kunde zahlte 350.- zu viel, sobald er Zubehoer dazulegte.
        // syncCartFast deckt Montage UND Versand UND Baugesuch ab und ersetzt beide Aufrufe.
        return new Promise(function (resolve) {
          if (window.syncCartFast) {
            window.syncCartFast(resolve);
          } else if (window.syncMontageInCart) {
            // Fallback fuer den Fall, dass sky-discount-system.js (noch) nicht geladen ist
            window.syncMontageInCart(function () {
              if (window.syncShippingInCart) {
                window.syncShippingInCart(resolve);
              } else {
                resolve();
              }
            });
          } else {
            resolve();
          }
        });
      })
      .then(function () {
        // Cart page: full reload so Liquid re-renders all rows with correct data attributes
        if (/\/cart(\?|$|\/?$)/.test(window.location.pathname)) {
          window.location.reload();
          return;
        }

        // Refresh cart drawer via Section Rendering API
        return fetch(
          "/cart.js?sections=cart-drawer&sections_url=" +
            encodeURIComponent(window.location.pathname)
        )
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (!data || !data["cart-drawer"]) return;
            var drawer = document.getElementById("Cart-Drawer");
            if (!drawer) return;
            var content = drawer.querySelector(".side-panel-content");
            if (!content) return;
            // CRITICAL: Extract INNER .side-panel-content from response (sections-API liefert
            // den ganzen <aside>-Wrapper). NIEMALS data["cart-drawer"] direkt in innerHTML
            // setzen — das nestet ein <aside> in .side-panel-content → Drawer-in-Drawer Bug.
            // Symptom: Drawer schliesst sich nach Upsell-Add, Layout kollabiert.
            var temp = document.createElement("div");
            temp.innerHTML = data["cart-drawer"];
            var newSpc = temp.querySelector(".side-panel-content");
            if (!newSpc) {
              // Defensive: response unerwartet ohne side-panel-content → abbrechen
              console.warn("[SKY-UPSELL] section response missing .side-panel-content, skipping update");
              return;
            }
            content.innerHTML = newSpc.innerHTML;
          });
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent("cart:refresh"));

        // Brief success feedback, then re-enable
        btn.classList.remove("thb-loading");
        btn.innerHTML = "&#10003;";
        setTimeout(function () {
          btn.innerHTML = "Hinzufügen";
          btn.disabled = false;
        }, 1200);

        // Apply discount prices after drawer refresh
        setTimeout(function () {
          if (window.applyCartDrawerDiscounts) window.applyCartDrawerDiscounts();
          if (window.applyCartPageDiscounts) window.applyCartPageDiscounts();
        }, 400);
      })
      .catch(function (err) {
        console.error("[SKY-UPSELL] Error:", err);
        btn.classList.remove("thb-loading");
        btn.disabled = false;
      });
  });

  // Variant select handler — updates item data when visitor picks a different variant
  document.addEventListener("change", function (e) {
    var select = e.target.closest("[data-upsell-variant-select]");
    if (!select) return;

    var item = select.closest("[data-upsell-item]");
    if (!item) return;

    var selectedId = select.value;
    var jsonEl = item.querySelector("[data-upsell-variants]");
    if (!jsonEl) return;

    try {
      var variants = JSON.parse(jsonEl.textContent);
      var data = variants[selectedId];
      if (!data) return;

      // Update data attributes on item
      item.setAttribute("data-variant-id", selectedId);
      item.setAttribute("data-variant-title", data.title);
      if (data.linkedMontageIds) {
        item.setAttribute("data-linked-montage-ids", data.linkedMontageIds);
      } else {
        item.removeAttribute("data-linked-montage-ids");
      }
      if (data.linkedShippingId) {
        item.setAttribute("data-linked-shipping-id", data.linkedShippingId);
      } else {
        item.removeAttribute("data-linked-shipping-id");
      }

      // Update button variant ID
      var btn = item.querySelector("[data-upsell-add]");
      if (btn) btn.setAttribute("data-variant-id", selectedId);

      // Update price display
      var priceEl = item.querySelector("[data-upsell-price]");
      if (priceEl) {
        priceEl.innerHTML = '<span class="amount">' + data.price + '</span>';
      }
    } catch (ex) {
      console.error("[SKY-UPSELL] Variant select error:", ex);
    }
  });
})();
